import { View } from 'dripsy';
import * as React from 'react';
import { Portal } from '../Portal';
import { usePopover } from './Popover';
const CLICK_OUTSIDE_EVENTS = ['mousedown', 'touchstart'];
const PopoverContent = ({ align = 'left', children, }) => {
    const { triggerRef, onOpenChange } = usePopover();
    const popoverContentRef = React.useRef();
    const [clientRect, setClientRect] = React.useState(triggerRef.current.getBoundingClientRect());
    React.useEffect(() => {
        const listener = (event) => {
            const shouldTrigger = [triggerRef, popoverContentRef].every((ref) => !!ref.current && !ref.current.contains(event.target));
            if (shouldTrigger)
                onOpenChange(false);
        };
        CLICK_OUTSIDE_EVENTS.forEach((fn) => document.addEventListener(fn, listener));
        return () => {
            CLICK_OUTSIDE_EVENTS.forEach((fn) => document.removeEventListener(fn, listener));
        };
    }, [triggerRef, popoverContentRef]);
    React.useEffect(() => {
        const onResize = () => setClientRect(triggerRef.current.getBoundingClientRect());
        const onKeyDown = (event) => {
            if (event.nativeEvent.key === 'Escape')
                onOpenChange(false);
        };
        setClientRect(triggerRef.current.getBoundingClientRect());
        document.addEventListener('keydown', onKeyDown);
        window.addEventListener('resize', onResize);
        return () => {
            document.removeEventListener('keydown', onKeyDown);
            window.removeEventListener('resize', onResize);
        };
    }, []);
    return (React.createElement(Portal, { position: "static", zIndex: "$3" },
        React.createElement(View, { sx: {
                position: 'absolute',
                borderRadius: 'default',
                boxShadow: 'pop',
                overflow: 'hidden',
                padding: '$4',
                backgroundColor: 'background',
                top: clientRect.bottom + 8 + window.scrollY,
                ...(align === 'left' && { left: clientRect.left }),
                ...(align === 'right' && { right: document.body.scrollWidth - clientRect.right }),
            }, ref: popoverContentRef, accessibilityRole: 'dialog' }, children)));
};
PopoverContent.displayName = 'PopoverContent';
const PopoverContentHOC = (props) => {
    const { isOpen, triggerRef } = usePopover();
    const [shouldRender, setShouldRender] = React.useState(isOpen && triggerRef.current);
    React.useEffect(() => {
        setShouldRender(isOpen && triggerRef.current);
    }, [isOpen, triggerRef.current]);
    if (!shouldRender)
        return null;
    return React.createElement(PopoverContent, { ...props });
};
export { PopoverContentHOC as PopoverContent };
//# sourceMappingURL=PopoverContent.js.map